interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  icon?: string;
}

export default function SectionHeading({ eyebrow, title, desc, icon }: SectionHeadingProps) {
  return (
    <div className="mb-6 md:mb-9">
      <span className="inline-flex items-center gap-2 text-xs md:text-sm font-medium text-secondary-700">
        {icon && (
          <span className="w-6 h-6 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-800">
            <i className={icon}></i>
          </span>
        )}
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
        {title}
      </h2>
      {desc && (
        <p className="mt-3 max-w-3xl text-sm md:text-base leading-relaxed text-foreground-700">
          {desc}
        </p>
      )}
    </div>
  );
}